import axios from "axios";
import FormData from 'form-data';
import { ComercialGeralConfig, TrocasConfig } from "../interfaces/Comercial";
class ConfigService {

    // vaor minimo
    async getPedidoValorMinimo(id): Promise<any> {
        return await (await axios.get("config/pedido/valor_min/" + id)).data;
    }

    async updateRegraPedidoMinimo(dados: any): Promise<any> {
        return await axios.patch("config/pedido/valor_min/" + dados.id, dados);
    }

    async createRegraPedidoMinimo(dados: any): Promise<any> {
        return await axios.post("config/pedido/valor_min", dados);
    }

    async deleteRegraPedidoMinimo(id): Promise<any> {
        return await axios.delete("config/pedido/valor_min/" + id);
    }

    async getAllPedidoValorMinimo(): Promise<any> {
        return await (await axios.get("config/pedido/valor_min")).data;
    }

    // comercial
    async getComercialConfig(): Promise<any> {
        return await axios.get("config/comercial")
    }

    updateComercialConfig(dados: ComercialGeralConfig & TrocasConfig): Promise<any> {
        return axios.post("config/comercial", dados)
    }

    // logistica
    async getLogisticaConfig(): Promise<any> {
        return await axios.get("config/logistica")
    }

    updateLogisticaConfig(dados: any): Promise<any> {
        return axios.post("config/logistica", dados);
    }

    // financeiro
    async getFinanceiroConfig(): Promise<any> {
        return await axios.get("config/financeiro")
    }

    updateFinanceiroConfig(dados: any): Promise<any> {
        return axios.post("config/financeiro", dados);
    }

    // estoque
    async getEstoqueConfig(): Promise<any> {
        return await axios.get("config/estoque")
    }

    updateEstoqueConfig(dados: any): Promise<any> {
        return axios.post("config/estoque", dados);
    }

    buscarConfigEmail(): Promise<any> {
        return axios.get("config/email");
    }

    salvarConfigEmail(dados: any): Promise<any> {
        if (dados?.password?.length == 0 || dados?.password == "$CRYPTED_WMC$") {
            dados.password = undefined;
        }

        if (!dados?.secure) {
            dados.secure = false;
        }

        return axios.post("config/email", dados);
    }

    testarEnvioEmail(): Promise<any> {
        return axios.post("email/teste/");
    }

    salvarConfigVisual(payload: any): Promise<any> {
        return axios.patch("config/app/visual", payload)
    }

    salvarConfigLinksRedes(payload: any): Promise<any> {
        return axios.patch("config/app/redessociais", payload);
    }

    salvarConfigLinksApp(payload: any): Promise<any> {
        return axios.patch("config/app/aplicativo", payload);
    }

    updateBannersConfig(data: { ordenation: { id: number }[] }): Promise<any> {
        return axios.post("config/app/banner/config", data);
    }

    adicionarConfigBanner(formData: FormData): Promise<any> {
        return axios.post("config/app/banner", formData);
    }

    atualizarConfigBanner(formData: FormData, id: number): Promise<any> {
        return axios.patch(`config/app/banner/${id}`, formData);
    }

    removerBanner(id: number): Promise<any> {
        return axios.delete(`config/app/banner/${id}`);
    }

    updatePaginasConteudoConfig(data: { ordenation: { id: number }[] }): Promise<any> {
        return axios.post("config/app/paginaconteudo/config", data);
    }

    adicionarConfigPgConteudo(payload: any): Promise<any> {
        return axios.post("config/app/paginaconteudo", payload);
    }

    atualizarConfigPgConteudo(payload: any, id: number): Promise<any> {
        return axios.patch(`config/app/paginaconteudo/${id}`, payload);
    }

    removerConfigPgConteudo(id: number): Promise<any> {
        return axios.delete(`config/app/paginaconteudo/${id}`);
    }

    buscarConfiguracoesApp(): Promise<any> {
        return axios.get("public/config/app");
    }

}

export default new ConfigService();